var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.252 28.2375C7.86522 28.2375 1.87628 22.2489 1.87628 14.8617C1.87628 7.47484 7.86484 1.4859 15.252 1.4859C22.6393 1.4859 28.6278 7.47446 28.6278 14.8617C28.6278 22.2489 22.6393 28.2375 15.252 28.2375ZM15.252 0C7.04425 0 0.390381 6.65387 0.390381 14.8617C0.390381 23.0699 7.04425 29.7237 15.252 29.7237C23.4602 29.7237 30.1141 23.0699 30.1141 14.8617C30.1141 6.65387 23.4602 0 15.252 0Z",
    fill: "#F87E03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3125 14.094C21.3129 14.2532 21.2721 14.4097 21.194 14.5485C21.116 14.6872 21.0034 14.8033 20.8672 14.8856L12.425 20.0501C12.2827 20.1373 12.1196 20.1848 11.9528 20.1879C11.7859 20.191 11.6212 20.1495 11.4758 20.0677C11.3317 19.9871 11.2117 19.8696 11.1281 19.7273C11.0444 19.585 11.0002 19.423 11 19.2579V8.93018C11.0002 8.76511 11.0444 8.60308 11.1281 8.46076C11.2117 8.31844 11.3317 8.20097 11.4758 8.12041C11.6212 8.03858 11.7859 7.99707 11.9528 8.00016C12.1196 8.00325 12.2827 8.05083 12.425 8.13799L20.8672 13.3024C21.0034 13.3847 21.116 13.5009 21.194 13.6396C21.2721 13.7783 21.3129 13.9349 21.3125 14.094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.83910644c6adb1ab2f1686ecc090a540.svg";
export { ForwardRef as ReactComponent };